/// <reference path="../types/index.d.ts" />

import '../client_forms/steamwhistle/style.css';
import FormStructure from './steamwhistle/form_structure';

export default FormStructure;